<template>
  <div
    class="onboarding-create-site__options-answers-square"
    :class="rectangle"
  >
    <div
      ref="answer"
      class="onboarding-create-site__options-answers-square--item"
      :class="`${rectangle}--item`"
      v-for="(item, index) in options"
      :key="index"
      v-on:click="getAnswerUser(item)"
    >
      <p class="onboarding-create-site__options-answers-square--emotion">
        {{ item.icon }}
      </p>
      <p class="onboarding-create-site__options-answers-square--text">
        {{ item.text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    rectangle: String,
  },

  data() {
    return {
      answerSteps: {},
    }
  },

  computed: {
    answerUser: {
      get() {
        return this.$store.state.onboardingCreateSite.answersOfStep
      },
      set(payload) {
        this.$store.dispatch('setAnswer', payload)
      },
    },

    nextStep: {
      get() {
        return this.$store.state.onboardingCreateSite.nextStep
      },
      set(payload) {
        this.$store.dispatch('setStep', payload)
      },
    },
  },

  mounted() {
    if (localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)) {
      this.answerSteps = JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )
    } else {
      localStorage.setItem(
        `onboarding_wed${this.answerUser.wed_id}`,
        JSON.stringify(this.answerSteps)
      )
    }

    if (
      !Object.keys(this.answerUser).length == 0 &&
      this.answerUser['step' + this.getStepNumber()]
    ) {
      this.active(this.answerUser['step' + this.getStepNumber()].id)
    }
  },

  methods: {
    getStepNumber() {
      const stepNumber = this.$route.params.id.split('-')
      return parseInt(stepNumber[1])
    },

    getAnswerUser(value) {
      this.active(value.id)
      this.nextStep = true

      const indexStep = this.getStepNumber()

      //save vuex to control of back and next
      let result = {}
      result.id = value.id
      result.answer = value
      this.answerUser['step' + indexStep] = result

      this.answerSteps = JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )

      //save localstorage
      if (this.getStepNumber() === 1) {
        this.answerSteps.couple_feeling = value.text

        // console.log(this.answerSteps)

        localStorage.setItem(
          `onboarding_wed${this.answerUser.wed_id}`,
          JSON.stringify(this.answerSteps)
        )
      } else if (this.getStepNumber() === 3) {
        this.answerSteps.website_goal = value.value

        localStorage.setItem(
          `onboarding_wed${this.answerUser.wed_id}`,
          JSON.stringify(this.answerSteps)
        )
      } else if (this.getStepNumber() === 7) {
        this.answerSteps.gifts_type = value.value
        localStorage.setItem(
          `onboarding_wed${this.answerUser.wed_id}`,
          JSON.stringify(this.answerSteps)
        )
      }
    },

    active(id) {
      const arrayClass = this.$refs.answer
      this.nextStep = true

      // remove class all itens
      for (let index = 0; index < arrayClass.length; index++) {
        const element = arrayClass[index]
        element.classList.remove(
          'onboarding-create-site__options-answers-square--item-active'
        )
      }

      // add class only item selected
      arrayClass[id].classList.add(
        'onboarding-create-site__options-answers-square--item-active'
      )
    },
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__options-answers-square {
    padding: 20px 20px 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    &--item {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 10px;
      min-height: 150px;
      border: 1px solid;
      border-radius: 8px;
      border: solid 1px $gray-4;
      cursor: pointer;
      padding: 10px 20px;

      &:hover {
        background-color: $gray-2;
      }

      @media (max-width: $tablet) {
        width: 100%;
        display: block;
        min-height: auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        align-content: center;
        justify-content: flex-start;
        padding: 10px;
        margin: 5px;

        p {
          padding: 5px;
          text-align: left;
        }
      }
    }
    &--emotion {
      font-size: 32px !important;
      margin-bottom: 5px;
    }

    &--text {
      font-size: 20px;
      color: $gray-6;
    }

    @media (max-width: $tablet) {
      flex-direction: column;
      width: 100%;
    }
  }

  &__options-answers-square-rectangle {
    display: block;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 10px;

    @media (min-width: $tablet) {
      width: 85%;
    }

    &--item {
      width: 100%;
      display: block;
      min-height: auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding: 3px 10px;
      align-items: center;

      p {
        font-size: 16px;
        padding: 7px;
        text-align: left;
        margin: 0;
      }
    }
  }

  &__options-answers-square {
    &--item-active {
      border: 2px solid $primary;
    }
  }
}
</style>
